import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//var Auth0Cordova = require('@auth0/cordova'); //Tommy - 10/06/2021 - For Auth0

/*
 * Plugins to add for auth0
 * 
 * npm install auth0-js
 * npm install @auth0/cordova
 * 
 * cordova plugin add cordova-plugin-safariviewcontroller
 * cordova plugin add cordova-plugin-customurlscheme --variable URL_SCHEME={package name} --variable ANDROID_SCHEME={package name} --variable ANDROID_HOST=*.auth0.com --variable ANDROID_PATHPREFIX=/cordova/{package name}/callback
 * cordova plugin add @globules-io/cordova-plugin-ios-xhr
 * cordova plugin add cordova-plugin-advanced-http
 * 
 */

//ReactDOM.render(<App />, document.getElementById('root'));

const startApp = () => {
  /* //Tommy - 10/06/2021 - For Auth0
   function intentHandler(url) {
     Auth0Cordova.onRedirectUri(url);
   }

   //Tommy - 10/06/2021 - For Auth0
  window.handleOpenURL = intentHandler; */

  ReactDOM.render(
    <App ref={(app) => { window.app = app }} />,
    document.getElementById('root')
  );
}

if (!window.cordova) {
  startApp()
} else {
  document.addEventListener('deviceready', startApp, false)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
//serviceWorker.register();
